import React from 'react';
import styled from 'styled-components';
import { IndentWidthType } from '../../../types';
const DocsPageContentSpace = ({ withSpace = IndentWidthType.NONE, ...rest }) => {
    return React.createElement(DocsPageContentSpaceWrapper, { withSpace: withSpace, ...rest });
};
export default DocsPageContentSpace;
const DocsPageContentSpaceWrapper = styled.div `
  display: block;
  margin-bottom: ${props => props.withSpace === IndentWidthType.NONE && '0px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.NONE && '5px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.XSMALL && '20px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.SMALL && '40px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.MEDIUM && '50px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.LARGE && '60px'};
`;
//# sourceMappingURL=DocsPageContentSpace.js.map